import React from 'react';
import { ScaleLoader } from 'react-spinners';

type BlockUiProps = React.HTMLAttributes<HTMLElement> & {
    blocking?: boolean;
    loader?: React.ReactNode;
    tag?: React.ElementType;
    renderChildren?: boolean;
    children?: React.ReactNode;
};

/**
 * Minimal in-house replacement for `react-block-ui`.
 */
const defaultLoader = <ScaleLoader color="var(--first)" loading />;

const BlockUi = ({
    tag: Tag = 'div',
    blocking = false,
    loader = defaultLoader,
    renderChildren = true,
    className,
    children,
    ...rest
}: BlockUiProps) => (
    <Tag {...rest} className={blocking ? `block-ui ${className ?? ''}` : className} aria-busy={blocking}>
        {(!blocking || renderChildren) && children}
        {blocking && (
            <div className="block-ui-container">
                <div className="block-ui-overlay" />
                <div className="block-ui-message-container">
                    <div className="block-ui-message">{loader}</div>
                </div>
            </div>
        )}
    </Tag>
);

export default BlockUi;
